import { derinApiClient } from "./setup";
import {
  DerinOrganization,
  DerinApiResponse,
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
} from "./interface";

export const getOrganizations = async (): Promise<DerinOrganization[]> => {
  const response = await derinApiClient().get<DerinApiResponse<DerinOrganization[]>>("/organization");
  return response.data.data;
};

export const getOrganizationById = async (orgId: string): Promise<DerinOrganization> => {
  const response = await derinApiClient().get<DerinApiResponse<DerinOrganization>>(`/organization/${orgId}`);
  return response.data.data;
};

export const createOrganization = async (data: CreateOrganizationRequest): Promise<DerinOrganization> => {
  const response = await derinApiClient().post<DerinApiResponse<DerinOrganization>>("/organization", data);
  return response.data.data;
};

export const updateOrganization = async (orgId: string, data: UpdateOrganizationRequest): Promise<DerinOrganization> => {
  const response = await derinApiClient().patch<DerinApiResponse<DerinOrganization>>(`/organization/${orgId}`, data);
  return response.data.data;
};

export const deleteOrganization = async (orgId: string): Promise<void> => {
  await derinApiClient().delete(`/organization/${orgId}`);
};
